export const businessListStyles = {
  headerContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: { sm: "space-between" },
    gap: { xs: "10px", sm: 0 },
    alignItems: "center",
  },
  createHeaderContainer: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
  },
  headerTitle: { fontSize: "17px", fontWeight: "600" },
  underlineHeading: {
    fontSize: "13px",
    fontWeight: "400",
    fontStyle: "italic",
  },
  btnStyle: {
    minWidth: { xs: "100%", sm: "165px" },
  },
};
